module.exports = __webpack_public_path__ + "static/8-0fb1aecd1a0d7de758bf8791e28d087a.jpeg";